<template>
  <div class="container mt-4 grupo-page">
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
      <div>
        <h2 class="mb-1"><i class="bi bi-people-fill me-2"></i>Grupo familiar</h2>
        <p class="text-muted mb-0">
          Invita por email y, al añadir un gasto, elige con quién compartirlo. El importe se divide entre las personas añadidas.
        </p>
      </div>
      <router-link to="/perfil" class="btn btn-outline-secondary btn-sm">
        <i class="bi bi-arrow-left me-1"></i>Volver al perfil
      </router-link>
    </div>

    <div v-if="mensaje" class="alert alert-success alert-dismissible fade show" role="alert">
      {{ mensaje }}
      <button type="button" class="btn-close" @click="mensaje = ''" aria-label="Cerrar"></button>
    </div>
    <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
      {{ error }}
      <button type="button" class="btn-close" @click="error = ''" aria-label="Cerrar"></button>
    </div>

    <div v-if="cargando" class="text-center py-5 text-muted">
      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
      Cargando grupos…
    </div>

    <template v-else>
      <div class="card mb-4" v-if="notificaciones.invitaciones.length">
        <div class="card-body">
          <h3 class="h5 mb-3">
            <i class="bi bi-bell-fill me-2 text-warning"></i>
            Invitaciones pendientes
            <span class="badge bg-danger ms-1">{{ notificaciones.invitaciones.length }}</span>
          </h3>

          <div
            v-for="inv in notificaciones.invitaciones"
            :key="'inv-' + inv.id"
            class="border rounded p-3 mb-2 d-flex flex-column flex-md-row justify-content-between gap-2"
          >
            <div>
              <strong>{{ inv.grupo_nombre }}</strong>
              <div class="small text-muted">{{ inv.invitado_por }} te ha invitado</div>
            </div>
            <div class="d-flex gap-2">
              <button class="btn btn-success btn-sm" :disabled="busy" @click="aceptarInvitacion(inv.id)">
                Aceptar
              </button>
              <button class="btn btn-outline-secondary btn-sm" :disabled="busy" @click="rechazarInvitacion(inv.id)">
                Descartar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-for="grupo in grupos" :key="grupo.id" class="card mb-4">
        <div class="card-body">
          <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
            <div>
              <h3 class="h5 mb-1">{{ grupo.nombre }}</h3>
              <span class="badge" :class="grupo.rol === 'creador' ? 'bg-primary' : 'bg-secondary'">
                {{ grupo.rol === 'creador' ? 'Creador' : 'Miembro' }}
              </span>
            </div>
            <div class="d-flex gap-2">
              <button
                v-if="grupo.rol !== 'creador'"
                class="btn btn-outline-danger btn-sm"
                :disabled="busy"
                @click="salir(grupo)"
              >
                Salir del grupo
              </button>
              <button
                v-else
                class="btn btn-outline-danger btn-sm"
                :disabled="busy"
                @click="eliminar(grupo)"
              >
                Eliminar grupo
              </button>
            </div>
          </div>

          <h4 class="h6">Miembros</h4>
          <ul class="list-group mb-3">
            <li
              v-for="m in grupo.miembros"
              :key="m.id"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{{ m.nombre }}</strong>
                <span class="text-muted small ms-2">{{ m.email }}</span>
                <span v-if="m.rol === 'creador'" class="badge bg-light text-dark border ms-2">Creador</span>
              </div>
              <button
                v-if="grupo.rol === 'creador' && m.id !== yoId"
                class="btn btn-sm btn-outline-danger"
                :disabled="busy"
                @click="quitarMiembro(grupo, m)"
              >
                Quitar
              </button>
            </li>
          </ul>

          <form class="row g-2 align-items-end" @submit.prevent="invitar(grupo)">
            <div class="col-md-8">
              <label class="form-label">Invitar por email</label>
              <input
                v-model="emailsInvitar[grupo.id]"
                type="email"
                class="form-control"
                placeholder="persona@correo.com"
                required
              >
            </div>
            <div class="col-md-4">
              <button class="btn btn-primary w-100" type="submit" :disabled="busy">
                Enviar invitación
              </button>
            </div>
          </form>

          <div v-if="grupo.invitaciones_pendientes && grupo.invitaciones_pendientes.length" class="mt-3">
            <h4 class="h6 text-muted mb-2">Invitaciones enviadas</h4>
            <ul class="list-unstyled small mb-0">
              <li v-for="inv in grupo.invitaciones_pendientes" :key="inv.id">
                {{ inv.email }} · pendiente
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-body">
          <h3 class="h5 mb-3">Crear un grupo</h3>
          <p class="text-muted small">
            Al tener un grupo, al añadir un gasto desaparece la opción Mitad/Total: se divide entre tú y las personas que marques.
          </p>
          <form class="row g-2 align-items-end" @submit.prevent="crear">
            <div class="col-md-8">
              <label class="form-label">Nombre del grupo</label>
              <input v-model="nuevoNombre" type="text" class="form-control" maxlength="80" placeholder="Familia" required>
            </div>
            <div class="col-md-4">
              <button class="btn btn-success w-100" type="submit" :disabled="busy">
                Crear grupo
              </button>
            </div>
          </form>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { onMounted, reactive, ref, computed } from 'vue';
import { useStore } from 'vuex';
import axios from '../config/axios';

export default {
  name: 'GrupoView',
  setup() {
    const store = useStore();
    const grupos = ref([]);
    const notificaciones = ref({ invitaciones: [], gastos_compartidos: [], total: 0 });
    const cargando = ref(true);
    const busy = ref(false);
    const error = ref('');
    const mensaje = ref('');
    const nuevoNombre = ref('Familia');
    const emailsInvitar = reactive({});
    const yoId = computed(() => store.state.auth?.user?.id);

    const cargar = async () => {
      cargando.value = true;
      error.value = '';
      try {
        const [g, n] = await Promise.all([
          axios.get('/api/grupos'),
          axios.get('/api/grupos/notificaciones')
        ]);
        grupos.value = g.data.grupos || [];
        // Sincroniza invitaciones y gastos pendientes para los badges del menú.
        notificaciones.value = n.data || { invitaciones: [], gastos_compartidos: [], total: 0 };
        store.commit('setNotificacionesGrupo', notificaciones.value);
      } catch (err) {
        error.value = err.response?.data?.error || 'No se pudieron cargar los grupos';
      } finally {
        cargando.value = false;
      }
    };

    const withBusy = async (fn, okMsg) => {
      busy.value = true;
      error.value = '';
      mensaje.value = '';
      try {
        await fn();
        if (okMsg) mensaje.value = okMsg;
        await cargar();
      } catch (err) {
        error.value = err.response?.data?.error || 'No se pudo completar la acción';
      } finally {
        busy.value = false;
      }
    };

    const crear = () => withBusy(async () => {
      await axios.post('/api/grupos', { nombre: nuevoNombre.value });
      nuevoNombre.value = 'Familia';
    }, 'Grupo creado. Ya puedes invitar por email.');

    const invitar = (grupo) => withBusy(async () => {
      const email = emailsInvitar[grupo.id];
      await axios.post(`/api/grupos/${grupo.id}/invitar`, { email });
      emailsInvitar[grupo.id] = '';
    }, 'Invitación enviada.');

    const aceptarInvitacion = (id) => withBusy(
      () => axios.post(`/api/grupos/invitaciones/${id}/aceptar`),
      'Te has unido al grupo.'
    );
    const rechazarInvitacion = (id) => withBusy(
      () => axios.post(`/api/grupos/invitaciones/${id}/rechazar`),
      'Invitación descartada.'
    );
    const salir = (grupo) => {
      if (!confirm(`¿Salir de «${grupo.nombre}»?`)) return;
      withBusy(() => axios.post(`/api/grupos/${grupo.id}/salir`), 'Has salido del grupo.');
    };
    const eliminar = (grupo) => {
      if (!confirm(`¿Eliminar el grupo «${grupo.nombre}»? Esta acción no se puede deshacer.`)) return;
      withBusy(() => axios.delete(`/api/grupos/${grupo.id}`), 'Grupo eliminado.');
    };
    const quitarMiembro = (grupo, m) => {
      if (!confirm(`¿Quitar a ${m.nombre} del grupo?`)) return;
      withBusy(() => axios.delete(`/api/grupos/${grupo.id}/miembros/${m.id}`), `${m.nombre} ya no está en el grupo.`);
    };

    onMounted(cargar);

    return {
      grupos,
      notificaciones,
      cargando,
      busy,
      error,
      mensaje,
      nuevoNombre,
      emailsInvitar,
      yoId,
      crear,
      invitar,
      aceptarInvitacion,
      rechazarInvitacion,
      salir,
      eliminar,
      quitarMiembro
    };
  }
};
</script>
